import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, retry } from 'rxjs';
import { environment } from '../../environments/environment';

export interface DecisionLogItem {
  id: string;
  projectId: string;
  number: string;
  date: string;
  decisionTaken: string;
  owner: string;
  comments?: string;
}

export interface CreateDecisionLogItemDto {
  projectId: string;
  number: string;
  date: string;
  decisionTaken: string;
  owner: string;
  comments?: string;
}

@Injectable({
  providedIn: 'root'
})
export class DecisionLogItemService {
  private apiUrl = `${environment.apiUrl}/DecisionLogItem`;

  constructor(private http: HttpClient) { }

  getByProjectId(projectId: string): Observable<DecisionLogItem[]> {
    return this.http.get<DecisionLogItem[]>(`${this.apiUrl}/project/${projectId}`);
  }

  getById(id: string): Observable<DecisionLogItem> {
    return this.http.get<DecisionLogItem>(`${this.apiUrl}/${id}`);
  }

  addItem(item: CreateDecisionLogItemDto): Observable<DecisionLogItem> {
    return this.http.post<DecisionLogItem>(this.apiUrl, item);
  }

  updateItem(id: string, item: DecisionLogItem): Observable<DecisionLogItem> {
    return this.http.put<DecisionLogItem>(`${this.apiUrl}/${id}`, item);
  }

  deleteItem(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}


